import React, {useEffect, useState} from 'react'
import { Dropdown, Grid, Segment, Input, Button, Icon } from 'semantic-ui-react'
import {useForm, Controller} from "react-hook-form"
import TwilioData from "../Sections/TwilioData"
import './style.css'

const Twillio = () => {
    const {
        register,
        control,
        handleSubmit,
        reset
    } = useForm()

    const [projects, setProject] = useState([])
    const [language, setLanguage] = useState([])
    const [responsible, setresponsible] = useState([])
    const [tags, setTags] = useState([])
    const [responseMessage, setResponseMessage] = useState('');
    const [refreshKey, setRefreshKey] = useState(0);

    const sqlString = (value) => {
        if (value === undefined || value === null || value === '') {
            return 'NULL';
        }

        return `'${value.toString().replace(/'/g, "''")}'`;
    }

    const sqlNumber = (value) => {
        if (value === undefined || value === null || value === '') {
            return 'NULL';
        }

        return Number(value);
    }

    const sqlJsonb = (value) => {
        const jsonValue = JSON.stringify(Array.isArray(value) ? value : []);

        return `'${jsonValue.replace(/'/g, "''")}'::jsonb`;
    }

    const buildTwilioInsertSql = (fields) => {
        const hiddenSource = fields.responsible?.toString() === '1' ? 'VICTORIA' : 'INDIVIDUAL';

        return `
INSERT INTO twillio_wa_map (
    "source details",
    responsible,
    ad_language,
    ad_project,
    marker,
    hidden_source,
    code,
    workflow_id,
    lead_distribution_groups_id,
    tags
)
VALUES (
    ${sqlString(fields.source_detail)},
    ${sqlNumber(fields.responsible)},
    ${sqlNumber(fields.Ad_Language)},
    ${sqlNumber(fields.Ad_Project)},
    ${sqlString(fields.marker)},
    ${sqlString(hiddenSource)},
    ${sqlString(fields.code)},
    NULL,
    NULL,
    ${sqlJsonb(fields.tags)}
)
RETURNING id;`.trim();
    }

    async function adProject(){
        const response = await fetch('https://crm.axcap.ae/rest/1/a9czkhedx3mmmn04/crm.lead.userfield.list?filter%5BFIELD_NAME%5D=UF_CRM_1568907438');
        const data = await response.json();
        setProject(data.result[0].LIST)
    }
    async function adLang(){
        const response = await fetch('https://crm.axcap.ae/rest/1/a9czkhedx3mmmn04/crm.lead.userfield.list?filter%5BFIELD_NAME%5D=UF_CRM_1553165368131');
        const data = await response.json();
        setLanguage(data.result[0].LIST)
    }
    
    async function adResponsible(){
        const response = await fetch('https://crm.axcap.ae/local/webhooks/getUserIdName.php?api_key=UPmcMSpk86SLPprv');
        const data = await response.json();
        setresponsible(data)
    }

    async function adTags(){
        const response = await fetch('https://crm.axcap.ae/rest/1/a9czkhedx3mmmn04/lists.element.get?IBLOCK_TYPE_ID=lists&IBLOCK_ID=189&ELEMENT_ORDER%5BID%5D=ASC&start=0');
        const data = await response.json();
        setTags(data.result)
    }

    useEffect(() => {
        adProject();
        adLang();
        adResponsible();
        adTags();
    }, [])
    console.log(responsible)


    const transformProject = projects.map(project => ({
        key: project.ID,
        text: project.VALUE,
        value: project.ID
    }))
    const transformLanguage = language.map(language => ({
        key: language.ID,
        text: language.VALUE,
        value: language.ID
    }))
    
    const transformResponsible = responsible.map(responsible => ({
        key: responsible.ID,
        text: responsible.NAME,
        value: responsible.ID
    }))
    const transformTags = tags.map(tag => ({
        key: tag.ID,
        text: tag.NAME,
        value: tag.ID
    }))
    transformResponsible.push({key: 1, text: 'AX CAPITAL', value: '1'})

    const onSubmit = async (fields) => {

            try {
                const sql = buildTwilioInsertSql(fields);
                const response = await fetch("https://api.axc.ae/webhook/b1acf1f9-ffab-4131-9379-7bfb7cea29fe", {
                    method: 'POST',
                    mode: 'cors', 
                    cache: 'no-cache',
                    credentials: 'same-origin',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    redirect: 'follow',
                    referrerPolicy: 'no-referrer',
                    body: JSON.stringify({fields, sql, "source": "twilio"}) 
                });

                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
        
                const data = await response.json(); // Получаем тело ответа в формате JSON
                setResponseMessage(data); 

                reset();
                setRefreshKey(prevKey => prevKey + 1);
            } catch (error) {
                console.error('Error:', error);
                setResponseMessage('An error occurred'); // Сообщение в случае ошибки
            }
        
    }

    
    return(
        <>
            <h1 className='title'>- Twillio -</h1>
            <form onSubmit={handleSubmit(onSubmit)}>
                <Grid container columns='equal' className='grid-form'>
                    <Grid.Row>
                        <Grid.Column>
                            <div className='item'>
                                <span>
                                    Campaign Code
                                </span>
                                <Controller
                                    name='code'
                                    defaultValue=""
                                    control={control}
                                    render={({field}) => <Input type='text' placeholder='Insert...' {...field}/>}
                                />
                                
                            </div>
                        </Grid.Column>
                        <Grid.Column>
                            <div className='item'>
                                <span>
                                    Responsible
                                </span>
                                <Controller
                                    name='responsible'
                                    control={control}
                                    render={({ field: { onChange, value, ...field } }) => (
                                        <Dropdown
                                            placeholder='select responsible'
                                            fluid
                                            search
                                            selection
                                            options={transformResponsible}
                                            value={value}
                                            // defaultValue="1"
                                            onChange={(e, data) => onChange(data.value)}
                                            {...field}
                                        />
                                    )} 
                                />
                            </div>
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                        <Grid.Column>
                            <div className='item'>
                                <span>
                                    Project
                                </span>
                                <Controller
                                    name='Ad_Project'
                                    control={control}
                                    render={({ field: { onChange, value, ...field } }) => (
                                        <Dropdown
                                            placeholder='Select Project'
                                            fluid
                                            search
                                            selection
                                            options={transformProject}
                                            value={value}
                                            onChange={(e, data) => onChange(data.value)}
                                            {...field}
                                        />
                                    )} 
                                />
                            </div>
                        </Grid.Column>
                        <Grid.Column>
                        <div className='item'>
                                <span>
                                    Language
                                </span>
                                <Controller
                                    name='Ad_Language'
                                    control={control}
                                    render={({ field: { onChange, value, ...field } }) => (
                                        <Dropdown
                                            placeholder='Select Language'
                                            fluid
                                            search
                                            selection
                                            options={transformLanguage}
                                            value={value}
                                            onChange={(e, data) => onChange(data.value)}
                                            {...field}
                                        />
                                    )} 
                                />
                            </div>
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                        <Grid.Column>
                            <div className='item'>
                                <span>
                                    Source Details
                                </span>
                                <Controller
                                    name='source_detail'
                                    defaultValue=""
                                    control={control}
                                    render={({field}) => <Input placeholder='Insert...' {...field}/>}
                                />
                            </div>
                        </Grid.Column>
                        <Grid.Column>
                        <div className='item'>
                                <span>
                                    Marker:
                                </span>
                                <Controller
                                    name='marker'
                                    defaultValue=""
                                    control={control}
                                    render={({field}) => <Input placeholder='Insert...' {...field}/>}
                                />
                            </div>
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                        <Grid.Column>
                            <div className='item'>
                                <span>
                                    Tags
                                </span>
                                <Controller
                                    name='tags'
                                    defaultValue={[]}
                                    control={control}
                                    render={({ field: { onChange, value, ...field } }) => (
                                        <Dropdown
                                            placeholder='Select Tags'
                                            fluid
                                            multiple
                                            search
                                            selection
                                            options={transformTags}
                                            value={value}
                                            onChange={(e, data) => onChange(data.value)}
                                            {...field}
                                        />
                                    )}
                                />
                            </div>
                        </Grid.Column>
                        <Grid.Column>
                        </Grid.Column>
                    </Grid.Row>
                    <Button animated className='fb-button'>
                        <Button.Content visible>Create Integration</Button.Content>
                        <Button.Content hidden>
                            <Icon name='arrow right' />
                        </Button.Content>
                    </Button>
                </Grid>
            </form>
            {responseMessage && (
                <div className='reponse-message'>
                    <p>Response: {responseMessage.message} | ID: {responseMessage.id}</p>
                </div>
            )}
            <TwilioData refreshKey={refreshKey}/>
        </>
    )
}

export default Twillio;
